// ─────────────────────────────────────────────────────────────────────────────
// Location Emails Actions
// ─────────────────────────────────────────────────────────────────────────────
// NgRx actions for the locationEmails store slice (per-location email registry
// consumed by the location-profile "Extra Emails" section).
// Covers list, create, update, delete, and a clear-error helper.
// Single-row mutations only; the backend exposes no batch endpoints.
// ─────────────────────────────────────────────────────────────────────────────

import { createAction, props } from '@ngrx/store';
import { APIResponse } from 'src/app/core/models/api-response';
import { ICreateLocationEmailPayload, ILocationEmail, IStructuredApiError, IUpdateLocationEmailPayload } from '../models/location-email.models';

// ── Load location emails ─────────────────────────────────────────────────────

export const LoadLocationEmails = createAction('[ LocationEmails ] - LoadLocationEmails', props<{ locationId: number }>());
export const LoadLocationEmailsSuccess = createAction(
  '[ LocationEmails ] - LoadLocationEmails Success',
  props<{ locationId: number; response: APIResponse<ILocationEmail> }>(),
);
export const LoadLocationEmailsError = createAction('[ LocationEmails ] - LoadLocationEmails Error', props<{ error: string }>());

// ── Load company-wide location emails ────────────────────────────────────────
// Fetches every location email under a company in one call (keyed by customerId)
// so the merged "Extra emails" list spans all of a company's stores.

export const LoadCompanyLocationEmails = createAction(
  '[ LocationEmails ] - LoadCompanyLocationEmails',
  props<{ customerId: number }>(),
);
export const LoadCompanyLocationEmailsSuccess = createAction(
  '[ LocationEmails ] - LoadCompanyLocationEmails Success',
  props<{ customerId: number; response: APIResponse<ILocationEmail> }>(),
);
export const LoadCompanyLocationEmailsError = createAction(
  '[ LocationEmails ] - LoadCompanyLocationEmails Error',
  props<{ error: string }>(),
);

// ── Create location email ────────────────────────────────────────────────────

export const CreateLocationEmail = createAction('[ LocationEmails ] - CreateLocationEmail', props<{ payload: ICreateLocationEmailPayload; customerId: number }>());
export const CreateLocationEmailSuccess = createAction('[ LocationEmails ] - CreateLocationEmail Success', props<{ email: ILocationEmail; customerId: number }>());
export const CreateLocationEmailError = createAction('[ LocationEmails ] - CreateLocationEmail Error', props<{ error: IStructuredApiError }>());

// ── Update location email ────────────────────────────────────────────────────

export const UpdateLocationEmail = createAction(
  '[ LocationEmails ] - UpdateLocationEmail',
  props<{ id: number; locationId: number; customerId: number; payload: IUpdateLocationEmailPayload }>(),
);
export const UpdateLocationEmailSuccess = createAction('[ LocationEmails ] - UpdateLocationEmail Success', props<{ email: ILocationEmail }>());
export const UpdateLocationEmailError = createAction(
  '[ LocationEmails ] - UpdateLocationEmail Error',
  props<{ error: IStructuredApiError; locationId: number }>(),
);

// ── Delete location email ────────────────────────────────────────────────────

export const DeleteLocationEmail = createAction('[ LocationEmails ] - DeleteLocationEmail', props<{ id: number; locationId: number; customerId: number }>());
export const DeleteLocationEmailSuccess = createAction(
  '[ LocationEmails ] - DeleteLocationEmail Success',
  props<{ id: number; locationId: number }>(),
);
export const DeleteLocationEmailError = createAction(
  '[ LocationEmails ] - DeleteLocationEmail Error',
  props<{ error: IStructuredApiError; locationId: number }>(),
);

// ── Misc ─────────────────────────────────────────────────────────────────────

export const ClearLocationEmailsError = createAction('[ LocationEmails ] - ClearError');
